import React, { createContext, useContext, useState, useCallback } from 'react';

const PaywallContext = createContext({
  showPaywall: false,
  triggerPaywall: () => {},
  dismissPaywall: () => {},
});

export const PaywallProvider = ({ children }) => {
  const [showPaywall, setShowPaywall] = useState(false);

  const triggerPaywall = useCallback(() => setShowPaywall(true), []);
  const dismissPaywall = useCallback(() => setShowPaywall(false), []);

  return (
    <PaywallContext.Provider value={{ showPaywall, triggerPaywall, dismissPaywall }}>
      {children}
    </PaywallContext.Provider>
  );
};

export const usePaywall = () => useContext(PaywallContext);
